import PropTypes from 'prop-types';
import styles from './FJCreationPreviewItem.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import FJAddIcon from '../../../assets/svg/aiGeneratorVideo/add.svg?react';
import FJConfig from '../../../config/FJConfig.js';
import FJResourceItemLoading from '../../components/FJResourceItemLoading/FJResourceItemLoading.jsx';
import FJUtil from '../../../util/FJUtil.js';
import ReloadIcon from '../../../assets/svg/reload.svg?react';

const FJCreationPreviewItem = props => {
    const { data = {}, use, width, height, randomIndex } = props;
    const { img } = data;

    const _getVideoUrl = () => {
        return FJConfig.videoEffectMediaPresetPath + randomIndex + '/' + img + '.mp4';
    };

    const [videoUrl, setVideoUrl] = useState(_getVideoUrl());
    const videoRef = useRef(null);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const _onPlay = () => {
        videoRef.current && videoRef.current.play();
    };
    const _onPause = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };
    const _edit = e => {
        e.stopPropagation();
        e.preventDefault();

        use({ ...data, randomIndex });
    };

    useEffect(() => {
        setVideoUrl(_getVideoUrl());
    }, [img, randomIndex]);

    const _onLoadedData = () => {
        setIsLoading(false);
    };

    const _onLoadStart = () => {
        setIsError(false);
        setIsLoading(true);
    };

    const _onError = () => {
        setIsError(true);
        setIsLoading(false);
    };

    const _refresh = () => {
        setIsError(false);
        setIsLoading(true);
        setVideoUrl(FJUtil.getReloadNewUrl(_getVideoUrl()));
    };

    return (
        <div
            className={classNames(styles.box)}
            onMouseEnter={_onPlay}
            onMouseLeave={_onPause}
            style={{ width, height }}
        >
            <video
                className={styles.video}
                muted
                loop
                ref={videoRef}
                src={videoUrl}
                onLoadedData={_onLoadedData}
                onLoadStart={_onLoadStart}
                onError={_onError}
            />
            {isLoading && <FJResourceItemLoading />}
            {isError && (
                <div className={styles.reload} onClick={_refresh}>
                    <ReloadIcon />
                </div>
            )}
            <FJIconButton
                className={classNames(styles.use_this)}
                textClassName={styles.use_this_text}
                text={FJLocalStore._('use-effect')}
                onClick={_edit}
                icon={<FJAddIcon />}
            />
            <div className={styles.desc}>
                <div className={styles.name}>{FJLocalStore._(data.name)}</div>
            </div>
        </div>
    );
};

FJCreationPreviewItem.propTypes = {
    data: PropTypes.object,
    use: PropTypes.func,
    width: PropTypes.number,
    height: PropTypes.number,
};
export default FJCreationPreviewItem;
